import React from "react";
import TypographyPoppins from "../TypographyPoppins";
import Link from "next/link";
import { FRONTEND_ENDPOINTS } from "@/public/Constants/endpoints";

const DashboardMenuCopyright = () => {
    return (
        <div className="flex flex-col items-start justify-center gap-y-3">
            <div className="flex gap-x-3">
                <Link href={FRONTEND_ENDPOINTS?.PRIVACY_POLICY}>
                    <TypographyPoppins
                        customStyle={
                            "!text-sm !font-normal underline !capitalize"
                        }
                        text="Privacy"
                    />
                </Link>
                <span className="mx-2 text-base font-[250]">|</span>
                <Link href={FRONTEND_ENDPOINTS?.TERMS_CONDITIONS}>
                    <TypographyPoppins
                        customStyle={
                            "!text-sm !font-normal underline !capitalize"
                        }
                        text="Terms & Conditions"
                    />
                </Link>
            </div>
            <TypographyPoppins
                customStyle={"!text-xs !font-light"}
                text="© Copyright 2025. All rights reserved."
            />
        </div>
    );
};

export default DashboardMenuCopyright;
